// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___M9Dt","rootNoMargin":"styles_rootNoMargin__2NO_w"};